module.exports = __webpack_public_path__ + "static/uthgardt_shaman-792b2eb558119eb3e11637e1bec3be89.png";